<template>
  <Dialog
      id="school-creation-modal"
      v-model:visible="visible"
      :header="t('CREATE_SCHOOL')"
      modal
      class="school-creation-modal"
      :draggable="false"
      :dismissable-mask="true"
      :style="{ width: '30rem' }"
  >
    <div class="row">
      <div class="col">
        <add-school-form
            ref="schoolFormRef"
            :manager-options="managerOptions"
            :module-options="moduleOptions"
            @submit-school="createSchool"
        />
      </div>
    </div>
    <template #footer>
      <Button :label="t('CONFIRM')" @click="schoolFormRef?.submitForm()" />
    </template>
  </Dialog>
</template>

<script setup>
import addSchoolForm from "@/views/components/forms/AddSchoolForm.vue";
import {onMounted, ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import {useToast} from "@/util/toastUtils";

const axios = injectAxios();
const {t} = useI18n();
const toast = useToast();

const schoolFormRef = ref(null);
const emit = defineEmits(["added-school"]);
const managerOptions = ref([]);
const moduleOptions = ref([]);
const visible = ref(false);

onMounted(() => {
  getSchoolManagers();
  getModules();
});

function showNewSchoolCreationModal() {
  visible.value = true;
}

async function createSchool(formData) {
  const response = await axios.post("/school/new-school", formData);
  toast.makeSuccessToast(t("ADDED_SCHOOL"));
  visible.value = false;
  emit("added-school", response.data);
}

async function getSchoolManagers() {
  const resp = await axios.get("/school/schools/managers/");
  managerOptions.value = resp.data;
}

async function getModules() {
  const resp = await axios.get("/training/unarchived");
  moduleOptions.value = resp.data;
}

defineExpose({
  showNewSchoolCreationModal,
});
</script>
